import type React from 'react';
import { useIntl } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Pill } from 'ui-components/components/pill';
import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';

import type { WorkflowStep } from '../../types';
import { messages } from './messages';
import styles from './styles.module.less';

type ActionStepContentProps = {
  step: WorkflowStep;
};

export const ActionStepContent: React.FC<ActionStepContentProps> = ({ step }) => {
  const intl = useIntl();

  return (
    <FlexRow gap={Gap.Space16}>
      <Pill className={styles['rule-pill']} label={intl.formatMessage(messages.ifAndThenPill)} theme='no-status' />
      <Text textType={TextType.Label} value={step.title.length > 0 ? step.title : intl.formatMessage(messages.defaultStepTitle)} />
    </FlexRow>
  );
};
